import { useUser } from 'src/hooks/queries/users';
import { UserUtils } from 'src/types/user.model';
import MoreInfoTooltip from 'src/components/more-info-tooltip/MoreInfoTooltip';
import LiteralsService from 'src/services/literals/LiteralsService';
import styles from 'src/components/atomic/organisms/transaction/frequencyTooltip/transactionFrequencyTooltip.module.scss';
import React from 'react';
import { HELP_DOMAIN } from 'src/utils/constants';
import { TransactionFrequencyTooltipModal } from 'src/types/view-models/transactions/transaction-frequency-tooltip.view.model';

export const TransactionFrequencyTooltip = ({ className, onClick }: TransactionFrequencyTooltipModal): JSX.Element => {
    const { data: user } = useUser();
    const projectionUrl: string = HELP_DOMAIN ? HELP_DOMAIN + '/articles/projections' : null;

    return UserUtils.isBudgetingUser(user) ? (
        <MoreInfoTooltip
            title={LiteralsService.getLiteral('TransactionsTable.heading.frequency.tooltipTitle')}
            body={LiteralsService.getJsxLiteral('TransactionsTable.heading.frequency.budget.body')}
            className={`${className || ''} ${styles.tooltipButton}`}
            buttonAriaLabel={LiteralsService.getLiteral('TransactionsTable.heading.frequency.tooltipTitle')}
            onClick={onClick}
        />
    ) : (
        <MoreInfoTooltip
            title={LiteralsService.getLiteral('TransactionsTable.heading.frequency.tooltipTitle')}
            body={LiteralsService.getJsxLiteral('TransactionsTable.heading.frequency.fullPlan.body')}
            className={`${className || ''} ${styles.tooltipButton}`}
            linkName={LiteralsService.getLiteral('TransactionsTable.heading.frequency.fullPlan.linkName')}
            buttonAriaLabel={LiteralsService.getLiteral('TransactionsTable.heading.frequency.tooltipTitle')}
            link={projectionUrl}
            internalLink
        />
    );
};
